import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import ActionButton from "./ActionButton";
import useThemeService from "../../../../../services/theme-service/ThemeService";
import { OrganizationSubscriptionPlansStorage } from "../../../../../services/organization-subscription-plans/OrganizationSubscriptionPlansStorage";
import useErrorHandler, {
  ApplicationError,
} from "../../../../../services/error-handler/ErrorHandlerService";
import { translationService } from "../../../../../services/translation/TranslationService";
import { snackbarNotificationsService } from "../../../../../services/notifications/SnackbarNotificationsService";

export interface CancelButtonProps {
  organizationSubscriptionPlansStorage: OrganizationSubscriptionPlansStorage;
}

export const CancelDowngradeButton = observer((props: CancelButtonProps) => {
  const { organizationSubscriptionPlansStorage } = props;

  const { themeClass } = useThemeService();
  const { handleErrorInSnackbar } = useErrorHandler();

  const handleCancelDowngradeClick = useCallback(async () => {
    try {
      await organizationSubscriptionPlansStorage.cancelDowngrade();
      snackbarNotificationsService.showSuccess("SubscriptionPlans.card.cancel-downgrade-success");
    } catch (error) {
      const applicationError = error as ApplicationError;
      handleErrorInSnackbar(applicationError);
    }
  }, [handleErrorInSnackbar, organizationSubscriptionPlansStorage]);

  return (
    <ActionButton
      confirmationAction={handleCancelDowngradeClick}
      className={themeClass(["btn-big"])}
      textKey={"SubscriptionPlans.card.cancel-downgrade"}
      confirmationButtonTextKey={"SubscriptionPlans.card.cancel-downgrade"}
      confirmationModalTitleKey={"SubscriptionPlans.card.cancel-downgrade-title"}
      hideCancelButtonOnModal
    >
      <div>
        {translationService.translate("SubscriptionPlans.card.cancel-downgrade-modal.part1")}
      </div>
      <br />
      <div>
        {translationService.translate("SubscriptionPlans.card.cancel-downgrade-modal.part2")}
      </div>
    </ActionButton>
  );
});
